import getNativeAdapterCreator from './native';

import {
  MediaStreamTypes,
  MediaStreamDeliveryPriority,
} from '../../../constants';

const defaultPlaybackAdapters = [
  getNativeAdapterCreator(
    MediaStreamTypes.DASH,
    MediaStreamDeliveryPriority.NATIVE_ADAPTIVE,
  ),
  getNativeAdapterCreator(
    MediaStreamTypes.HLS,
    MediaStreamDeliveryPriority.NATIVE_ADAPTIVE,
  ),
  getNativeAdapterCreator(
    MediaStreamTypes.MP4,
    MediaStreamDeliveryPriority.NATIVE_PROGRESSIVE,
  ),
  getNativeAdapterCreator(
    MediaStreamTypes.WEBM,
    MediaStreamDeliveryPriority.NATIVE_PROGRESSIVE,
  ), // Native WebM (Chrome, Firefox)
];

export default defaultPlaybackAdapters;



// WEBPACK FOOTER //
// ./default-modules/playback-engine/adapters/default-set.ts